//create component for partner contact avatar

import { getAvatarInitials } from '@/services/organization';
import { ORGANIZATION_CONTACT_PHOTO_EXTENSION } from '@bariendo/lib/extensions';
import { Avatar, Tooltip } from '@mantine/core';
import { formatHumanName } from '@medplum/core';
import { Attachment, OrganizationContact } from '@medplum/fhirtypes';

export function PartnerContactAvatar({ contact, size = 'sm' }: { contact: OrganizationContact; size?: string }) {
  const contactName = formatHumanName(contact.name);

  return (
    <Tooltip label={contactName}>
      <Avatar size={size} src={getContactPhoto(contact)?.url} name={getAvatarInitials(contact.name)} />
    </Tooltip>
  );
}
function getContactPhoto(contact: OrganizationContact): Attachment | undefined {
  return contact.extension?.find((e) => e.url === ORGANIZATION_CONTACT_PHOTO_EXTENSION)?.valueAttachment;
}
